import $ from 'jquery';
import _ from 'underscore';

import skUI from '../components/sk-ui';
import {
  addSocialLinkClickHandlers,
  blogSocialShare
} from './helpers/sk-blog-social-share';

function attachSocialShareScrollHandler() {
  const blog = $('.blog');
  const blogShare = $('.blog__share');
  const shareIcons = $('.blog__share__icons');
  const shareIconsFixedPositionFromTop = 330;
  let hasAttached = false;

  const positionBlogShare = () => {
    if (hasAttached) {
      // move share icons to position fixed if it lower on the screen
      // than it would be if it was position fixed (e.g. when scrolling too far up)
      if (
        shareIcons[0].getBoundingClientRect().top >
        shareIconsFixedPositionFromTop
      ) {
        hasAttached = false;
        blogShare.removeClass('attach-bottom-content');
        blog.css({ position: 'static' });
      }
    } else {
      const shareIconsBottom = shareIcons.offset().top + shareIcons.height();
      const blogRelatedTop = $('.blog__related').offset().top;
      // test to see if bottom of share icons is below the top of blog related articles
      if (shareIconsBottom >= blogRelatedTop) {
        hasAttached = true;
        blogShare.addClass('attach-bottom-content');
        blog.css({ position: 'relative' });
      }
    }
  };

  $(window).scroll(_.throttle(positionBlogShare, 10));

  $(document).ready(() => {
    positionBlogShare();
  });
}

const blog = {
  post: {
    blockLinks() {
      const blockLinks = $("strong:contains('SEE ALSO')");
      blockLinks.parent().addClass('link-block');
    }
  },
  social: {
    pinterest() {
      if (!$('.single-post') && !$('.blog')) return;

      const postUrl = window.location.href;
      const postImages = $('.blog__content > img, .blog__header__image img');
      const postTitle = $('h1')[0].textContent;

      function pinterestTemplate(imageUrl) {
        const template = `
          <a
            class="social-icons__pinterest social-button"
            href="https://www.pinterest.com/pin/create/button/"
            data-pin-do="buttonPin"
            data-pin-custom="true"
            data-pin-media="${imageUrl}"
            data-pin-description="${postTitle}"
            data-pin-url="${postUrl}">
            <span>pinterest</span>
          </a>
        `;

        return $(template).on('click', () => {
          blogSocialShare('pinterest', imageUrl);
        });
      }

      _.each(postImages, (image) => {
        $(image)
          .wrap('<figure class="blog__image-wrapper"></figure>')
          .after(pinterestTemplate(image.currentSrc));
      });
    },

    fixed() {
      const iframeHandler = (resizeFunction) => {
        let timer = 0;
        const documentObj = $(document);
        let currentHeight = documentObj.height();
        const t = setInterval(() => {
          if (documentObj.height() !== currentHeight) {
            currentHeight = documentObj.height();
            resizeFunction();
          }
          if (timer > 10) {
            clearInterval(t);
          }
          timer++;
        }, 1000);
      };

      const headerImage = $(
        '.blog__header__image, .blog__header--talking-shop'
      );

      $(window).on('load', () => {
        const blogPost = $('.single-post .blog');
        const blogShare = $('.blog__share');
        const blogWrapper = $('.blog__share__wrapper');

        if (blogPost) {
          attachSocialShareScrollHandler();
        } else {
          const main = $('#main');
          const shareTop = 439;
          skUI.onScrollBy.init(
            $('#footer'),
            () => {
              return (
                $(window).height() - (shareTop + $('#footer').outerHeight())
              );
            },
            false,
            true,
            () => {
              main.addClass('relative');
              blogShare.addClass('attach-bottom');
            },
            () => {
              blogShare.removeClass('attach-bottom');
              main.removeClass('relative');
            },
            iframeHandler
          );
        }

        skUI.onScrollBy.init(
          headerImage,
          () => {
            return headerImage.height() - skUI.onScrollBy.mobileNavHeight + 5;
          },
          true,
          true,
          () => {
            blogWrapper.addClass('attach-top');
          },
          () => {
            blogWrapper.removeClass('attach-top');
          }
        );
      });
    },

    clickInit() {
      addSocialLinkClickHandlers();
    }
  },

  ad: {
    init() {
      const headerObj = $('h3.blog-sql:first');
      const blogAd = `
        <ui-lightbox-button target="lightboxVideoBlog" class="blog-sql-link" youtube-id="U1H_zM7HtXE">
          <img src="/wp-content/themes/dt-the7-child/assets/images/layouts/campaigns/sk-blog-sql.gif" alt="See ShopKeep in Action"/>
        </ui-lightbox-button>
      `;
      $(blogAd).insertBefore(headerObj);
    }
  },

  resource() {
    const resource = $('.blog__resource');
    const resourceContainer = $('#resource-container');

    if (!resource.length) return;

    const resourceSlug = resource[0].getAttribute('data-slug');

    if (resourceSlug) {
      document.cookie = `_sk_resource=${resourceSlug}`;
    }

    if (!resourceContainer.length) return;

    resource.detach();
    resourceContainer.append(resource);
  },

  sqlBlock() {
    const sql = $('.blog__sql');
    const sqlContainer = $('#sql-block-container');

    if (!(sql.length && sqlContainer.length)) {
      return;
    }

    sql.detach();
    sqlContainer.append(sql);
  },

  media() {
    const media = $('.blog__content').find('p > img, p > iframe');

    if (!media.length) {
      return;
    }

    media.unwrap();
  },

  links() {
    const links = $('.blog__content').find('a');

    if (!links.length) {
      return;
    }

    links.attr('target', '_blank');
  },

  youtubeEmbed() {
    const youtubeEmbed = $('.blog__content').find('iframe');

    if (!youtubeEmbed.length) {
      return;
    }

    youtubeEmbed.wrap('<div class="blog__content__embed"></div>');
  }
};

$(() => {
  blog.social.fixed();
  blog.social.clickInit();
  blog.resource();
  blog.sqlBlock();
  blog.media();
  blog.links();
  blog.youtubeEmbed();
  blog.ad.init();
  blog.social.pinterest();
  blog.post.blockLinks();
});
